<template>
    <div>
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                  v-if="isClicked === true"></span>
        </div>
        <div  role="alert" id="alert" v-on:click="closeAlert">
            <i class="fa fa-times" aria-hidden="true" id="close" style="float: right"></i>
            <p class="remove-margin" id="contentAlert"></p>
        </div>
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center"
                 style="margin:0; padding: 12px 20px; font-weight: 550;">
                <div class="col-md-3 col-sm-3 col-3" style="padding: 0px;" @click="logout">
                    <img src="../../assets/img/x2.svg" alt="">
                </div>
                <div class="col-md-6 col-sm-6 col-6 text-center">
                    <p style="margin:0;">Akun Anda</p>
                </div>
                <div class="col-md-3 col-sm-3 col-3">
                </div>
            </div>
        </div>
        <div class="contain-body akun-anda">
            <div class="container remove-padding">
                <div class="row justify-content-center align-items-center remove-padding-margin">
                    <div class="col-md-12 remove-padding">
                        <div class="text-left text" style="margin-bottom: 42px; margin-top: 24px">
                            Nomor Anda terdaftar lebih dari satu akun. Silahkan pilih akun untuk login.
                        </div>
                        <div class="remove-padding-margin">
                            <p class="font-weight-bold">Pilih Akun</p>
                            <hr>
                            <div v-for="owner in owners" :key="owner.idowner">
                                <div v-on:click="signIn(owner.idowner)">
                                    <img src="../../assets/icons/right.png" alt=""
                                         style="margin-top:10px;width:25px;float:right">
                                    <h6 class="font-weight-bold color-0000">
                                        {{ owner.nama}}
                                    </h6>
                                    <h6 class="color-8080" v-if="owner.email !== ''">
                                        {{ owner.email }}
                                    </h6>
                                    <h6 class="color-8080" v-else>
                                        <i>emai belum diset</i>
                                    </h6>
                                    <hr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'AkunLogin',
        mounted() {
            this.getOTP();
            $('#close').hide()
        },
        data() {
            return {
                owners: [],
                isClicked: false,
            }
        },
        methods: {
            async getOTP() {
                try {
                    var telp = localStorage.getItem("telp");
                    const res = await this.$axios.get(this.$baseurl + '/auth/loginwa?telp=' + telp)
                    this.owners = res.data.data;
                    console.log(res.status)
                    console.log(res.data)
                } catch (e) {
                    if (!e.code) {
                        $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        setTimeout(() => {
                            $('#alert').removeClass("alert alert-danger animated fadeInDown");
                            $('#alert').addClass("alert alert-danger animated fadeOutUp");
                        }, 30000)
                        this.isClicked = false
                        $('#textbtn').show();
                        $('#nextbutton').prop('disabled', false);
                    }
                    else if (e.response.status === 500) {
                        $('#contentAlert').text(e.response.data.msg);
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        this.isClicked = false
                        $('#textbtn').show();
                        $('#nextbutton').prop('disabled', false);
                    }else {
                        $('#contentAlert').text(e.response.data.msg);
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        this.isClicked = false
                        $('#textbtn').show();
                        $('#nextbutton').prop('disabled', false);
                    }
                }
            },

            logout(){
                var myItem = localStorage.getItem('incontext-device');
                localStorage.clear();
                localStorage.setItem('incontext-device',myItem);
                this.$router.push('login')
            },

            closeAlert() {
                $('#alert').removeClass("alert alert-danger animated fadeInDown");
                $('#alert').addClass("alert alert-danger animated fadeOutUp");
            },

            async signIn(key) {
                this.isClicked = true;
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var telp = localStorage.getItem("telp")
	                var super_owner_key = localStorage.getItem("super_owner_key");
                    const dataForm = new FormData;
                    const appUserAgent = navigator.userAgent
                    dataForm.append('user_agent', appUserAgent)
                    dataForm.append('idowner', key);
                    dataForm.append('telp', telp);
                    dataForm.append('super_owner_key', super_owner_key)
                    const res = await this.$axios.post(this.$baseurl + '/auth/subakunsign', dataForm)
                    localStorage.setItem("token", res.data.data.token)
                    localStorage.setItem("idowner", res.data.data.idowner)
	                localStorage.removeItem("super_owner_key")
                    this.$router.push('/successlogin')
                } catch (e) {
                    this.isClicked = false;
                    $('#loadingPage').removeClass('overlayLoading');
                    if (!e.code) {
                        $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        setTimeout(() => {
                            $('#alert').removeClass("alert alert-danger animated fadeInDown");
                            $('#alert').addClass("alert alert-danger animated fadeOutUp");
                        }, 30000)
                        this.isClicked = false
                        $('#textbtn').show();
                        $('#nextbutton').prop('disabled', false);
                    }
                    else if (e.response.status === 500) {
                        $('#contentAlert').text(e.response.data.msg);
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        this.isClicked = false
                        $('#textbtn').show();
                        $('#nextbutton').prop('disabled', false);
                    }else {
                        $('#contentAlert').text(e.response.data.msg);
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        this.isClicked = false
                        $('#textbtn').show();
                        $('#nextbutton').prop('disabled', false);
                    }
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },
        },
    }
</script>
<style scoped>
    .overlayLoading {
        position: fixed;
        display: inline;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: white;
        z-index: 9999;
    }

    .spinner-border-sm {
        width: 2rem;
        height: 2rem;
        border-width: .3em;
        top: 40% !important;
        text-align: center;
        margin-top: 70%;
        margin-left: 45%;
        color: #007bff;
    }
</style>